// @ts-nocheck

import { create } from "zustand";
import { devtools } from "zustand/middleware";
import {
  SelectProps,
  TechnicianTreeMapData,
  TecnicianTreeMapClockData,
  WorkOccupationData,
} from "../components/charts/tim-toa/types";

interface Store {
  centerCost: SelectProps[];
  setCenterCost: (newData: SelectProps[]) => void;
  branch: SelectProps[];
  setBranch: (newData: SelectProps[]) => void;
  startDate: string;
  setStartDate: (newData: string) => void;
  endDate: string;
  setEndDate: (newData: string) => void;
  totalEmployees: number;
  setTotalEmployees: (newData: number) => void;
  currentEmployeesWorkingData: TechnicianTreeMapData[];
  setCurrentEmployeesWorkingData: (newData: TechnicianTreeMapData[]) => void;
  loadingChartCurrentEmployeesWorking: boolean;
  setLoadingChartCurrentEmployeesWorking: (newData: boolean) => void;
  loadingChartClockRegisterEmployees: boolean;
  setLoadingChartClockRegisterEmployees: (newData: boolean) => void;
  clockRegisterEmployeesData: TecnicianTreeMapClockData[];
  setClockRegisterEmployeesData: (newData: TecnicianTreeMapClockData[]) => void;
  workOccupationData: WorkOccupationData | null;
  setWorkOccupationData: (newData: WorkOccupationData) => void;
  loadingChartWorkOccupation: boolean;
  setLoadingChartWorkOccupation: (newData: boolean) => void;
  loadingChartEmployeeStatus: boolean;
  setLoadingChartEmployeeStatus: (newData: boolean) => void;
  employeeStatusData: any | null;
  setEmployeeStatusData: (newData: any) => void;
  loadingChartPriorityByTime: boolean;
  setLoadingChartPriorityByTime: (newData: boolean) => void;
  priorityByTimeData: any | null;
  setPriorityByTimeData: (newData: any) => void;
  loadingChartOpenCloseTSK: boolean;
  setLoadingChartOpenCloseTSK: (newData: boolean) => void;
  openCloseTSKData: any | null;
  setOpenCloseTSKData: (newData: any) => void;
  //
  loadingChartFleet: boolean;
  setLoadingChartFleet: (newData: boolean) => void;
  fleetData: any | null;
  setFleetData: (newData: any) => void;
}

const useStoreTimToa = create<Store>()(
  devtools(
    (set, _) => ({
      centerCost: [],
      setCenterCost: (newData: SelectProps[]) => {
        set({ centerCost: newData });
      },
      branch: [],
      setBranch: (newData: SelectProps[]) => {
        set({ branch: newData });
      },
      startDate: "",
      setStartDate: (newData: string) => {
        set({ startDate: newData });
      },
      endDate: "",
      setEndDate: (newData: string) => {
        set({ endDate: newData });
      },
      totalEmployees: 0,
      setTotalEmployees: (newData: number) => {
        set({ totalEmployees: newData });
      },
      currentEmployeesWorkingData: [],
      setCurrentEmployeesWorkingData: (newData: TechnicianTreeMapData[]) => {
        set({ currentEmployeesWorkingData: newData });
      },
      loadingChartCurrentEmployeesWorking: false,
      setLoadingChartCurrentEmployeesWorking: (newData: boolean) => {
        set({ loadingChartCurrentEmployeesWorking: newData });
      },
      loadingChartClockRegisterEmployees: false,
      setLoadingChartClockRegisterEmployees: (newData: boolean) => {
        set({ loadingChartClockRegisterEmployees: newData });
      },
      clockRegisterEmployeesData: [],
      setClockRegisterEmployeesData: (newData: TecnicianTreeMapClockData[]) => {
        set({ clockRegisterEmployeesData: newData });
      },
      workOccupationData: null,
      setWorkOccupationData: (newData: WorkOccupationData) => {
        set({ workOccupationData: newData });
      },
      loadingChartWorkOccupation: false,
      setLoadingChartWorkOccupation: (newData: boolean) => {
        set({ loadingChartWorkOccupation: newData });
      },
      loadingChartEmployeeStatus: false,
      setLoadingChartEmployeeStatus: (newData: boolean) => {
        set({ loadingChartEmployeeStatus: newData });
      },
      employeeStatusData: null,
      setEmployeeStatusData: (newData: any) => {
        set({ employeeStatusData: newData });
      },
      loadingChartPriorityByTime: false,
      setLoadingChartPriorityByTime: (newData: boolean) => {
        set({ loadingChartPriorityByTime: newData });
      },
      priorityByTimeData: null,
      setPriorityByTimeData: (newData: any) => {
        set({ priorityByTimeData: newData });
      },
      loadingChartOpenCloseTSK: false,
      setLoadingChartOpenCloseTSK: (newData: boolean) => {
        set({ loadingChartOpenCloseTSK: newData });
      },
      openCloseTSKData: null,
      setOpenCloseTSKData: (newData: any) => {
        set({ openCloseTSKData: newData });
      },
      //
      loadingChartFleet: false,
      setLoadingChartFleet: (newData: boolean) => {
        set({ loadingChartFleet: newData });
      },
      fleetData: null,
      setFleetData: (newData: any) => {
        set({ fleetData: newData });
      },
    }),
    {
      enabled: true,
      name: "Tim Toa Indicadores Store",
    }
  )
);

export default useStoreTimToa;
